module.exports = "https://cdn.hellotech.com/client-assets/tvmount33-60_77741fe35cbb04cd82b8823e0ed47cf5.png";